<template>
	<v-dialog v-model="localValue" max-width="300" :persistent="submitLoading" attach eager>
		<v-form ref="form" @submit.prevent="submit" :disabled="submitLoading">
			<v-card>
				<v-card-title class="justify-center text-capitalize primary--text">
					<v-btn @click="localValue = false" icon>
						<v-icon>$close</v-icon>
					</v-btn>
					<v-spacer/>
					<span class="me-8">
						{{$T('components.change-password')}}
					</span>
					<v-spacer/>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row dense>
						<!-- password -->
						<v-col cols="12">
							<v-text-field
								v-model="dialogData.password"
								:label="$T('inputs.password')"
								:type="dialogData.showPassword ? 'text' : 'password'"
								outlined
								dense
								hide-details
								:append-icon="dialogData.showPassword ? 'mdi-eye-off' : 'mdi-eye'"
								@click:append="dialogData.showPassword = !dialogData.showPassword"
								:rules="rules.password"
							/>
						</v-col>
						
						<!-- confirm-password -->
						<v-col cols="12">
							<v-text-field
								v-model="dialogData.confirmPassword"
								:label="$T('inputs.confirm-password')"
								:type="dialogData.showPassword ? 'text' : 'password'"
								outlined
								dense
								hide-details
								:append-icon="dialogData.showPassword ? 'mdi-eye-off' : 'mdi-eye'"
								@click:append="dialogData.showPassword = !dialogData.showPassword"
								:rules="[val => dialogData.password === val]"
							/>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn type="submit" color="primary" :loading="submitLoading">
						{{$T('save')}}
					</v-btn>
					<v-btn @click="localValue = false" :disabled="submitLoading">
						{{$T('close')}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import rules from '@/helpers/validation-rules'
export default {
	name: 'ChangePasswordDialog',

	props: {
		userId: { type: String },
		value: { type: Boolean, default: false, }
	},

	data: () => ({
		submitLoading: false,
		rules,

		// data
		dialogData: {
			password: null,
			confirmPassword: null,
			showPassword: false,
		},
	}),

	watch: {
		value(val) {
			if (!val) {
				this.$refs.form.reset();
				this.dialogData.showPassword = false;
			}
		}
	},

	computed: {
		localValue: {
			get() { return this.value },
			set(val) { this.$emit('input', val); }
		}
	},

	methods: {
		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				this.$store.dispatch('users/update', {
					id: this.userId,
					password: this.dialogData.password,
				}).then(() => {
					this.localValue = false;
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},
	}
}
</script>

<style>

</style>